module.exports = __webpack_public_path__ + "static/female-pic-80477dfa16f8e91dec437b79bb12c762.jpg";